import ProductModal from './ProductModal';
import React, { useContext, useEffect, useState } from 'react';
import { ModalContext } from '../Modal/modalContext';
import styles from './ProductButton.module.scss';
import { fetchProduct } from '../../functions';
import ProductPrice from './ProductPrice';
import Tooltip from '../Tooltip/Tooltip';
import { DataContext } from '../../views/pages/Root';

const ProductButton = ({ point }) => {
  const data = useContext(DataContext);
  let { handleModal } = React.useContext(ModalContext);

  const [product, setProduct] = useState(null);
  const [productLoader, setProductLoader] = useState(true);

  useEffect((_) => {
    // fetchProduct(point.prodID, setProduct, setProductLoader);
    const tempProduct = fetchProduct(point?.product, setProduct, setProductLoader, data);
  }, []);

  return (
    (!!product || !!point?.description || !!point?.title) && (
      <Tooltip point={point} type={!!point?.product ? 'product' : 'productInfo'} key={point?.id}>
        {!!point?.title && <p className={styles.nameProduct}>{point.title}</p>}
        {!!point?.description && <p className={styles.description}>{point.description}</p>}
        {!!product && (
          <>
            {!!product?.name && <p className={styles.nameProduct}>{product.name}</p>}
            <ProductPrice product={product} />
            <button className={styles.btnProduct} onClick={() => handleModal(<ProductModal id={point.product} />)}></button>
          </>
        )}
      </Tooltip>
    )
  );
};

export default ProductButton;
